export const PluginLoadingState = {
  NotApplicable: 'NotApplicable',
  PreLoading: 'PreLoading',
  Loading: 'Loading',
  LoadingSuccess: 'LoadingSuccess',
  LoadingFail: 'LoadingFail'
};
